'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useToast } from '@common/hooks';
import { cn } from '@core/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthApi } from '@/api';
import { Image } from '@/components/client';
import { BREAKPOINTS, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
const WELLPOINT_IMAGE_URL = 'https://cdn.welfarehello.com/static/wellpoint.png';
interface PurchaseConfirmModalProps {
  orderId: string;
  orderNo: string;
  productId: string;
  opened: boolean;
  onClose: () => void;
}
export const PurchaseConfirmModal = t0 => {
  const $ = _c(40);
  const {
    orderId,
    orderNo,
    productId,
    opened,
    onClose
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  const router = useCustomRouter();
  const {
    toast
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== orderId || $[1] !== productId) {
    t1 = () => AuthApi["put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/confirm"]({
      path: {
        orderId,
        productId
      }
    });
    $[0] = orderId;
    $[1] = productId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryClient || $[4] !== toast) {
    t2 = async () => {
      await queryClient.invalidateQueries();
      toast({
        message: "\uAD6C\uB9E4\uAC00 \uD655\uC815\uB418\uC5C8\uC5B4\uC694."
      });
    };
    $[3] = queryClient;
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== toast) {
    t3 = () => {
      toast({
        type: "fail",
        message: "\uAD6C\uB9E4 \uD655\uC815\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694."
      });
    };
    $[6] = toast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    mutateAsync: confirmPurchase,
    isPending
  } = useMutation(t4);
  let t5;
  if ($[12] !== confirmPurchase || $[13] !== onClose) {
    t5 = async () => {
      await confirmPurchase();
      onClose();
    };
    $[12] = confirmPurchase;
    $[13] = onClose;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleConfirmOnly = t5;
  let t6;
  if ($[15] !== confirmPurchase || $[16] !== onClose || $[17] !== orderId || $[18] !== orderNo || $[19] !== productId || $[20] !== router) {
    t6 = async () => {
      await confirmPurchase();
      router.push(ROUTES.MY_ORDERS_REVIEW_CREATE.withSearchParams({
        dynamicPath: {
          orderNo
        },
        searchParams: {
          productId,
          orderId
        }
      }));
      onClose();
    };
    $[15] = confirmPurchase;
    $[16] = onClose;
    $[17] = orderId;
    $[18] = orderNo;
    $[19] = productId;
    $[20] = router;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const handleConfirmAndReview = t6;
  const t7 = isDesktop ? "H56" : "H48";
  let t8;
  if ($[22] !== handleConfirmAndReview || $[23] !== isPending || $[24] !== t7) {
    t8 = <Button theme="sub-fill" dimensions={t7} onClick={handleConfirmAndReview} disabled={isPending}>후기 작성하고 500P 받기</Button>;
    $[22] = handleConfirmAndReview;
    $[23] = isPending;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const t9 = isDesktop ? "H56" : "H48";
  let t10;
  if ($[26] !== handleConfirmOnly || $[27] !== isPending || $[28] !== t9) {
    t10 = <Button theme="sub-text" dimensions={t9} className="text-Gray-white" onClick={handleConfirmOnly} disabled={isPending}>구매 확정</Button>;
    $[26] = handleConfirmOnly;
    $[27] = isPending;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t8) {
    t11 = <div className="flex flex-col gap-8">{t8}{t10}</div>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Image src={WELLPOINT_IMAGE_URL} alt={"\uC6F0\uD3EC\uC778\uD2B8 \uC774\uBBF8\uC9C0"} width={80} height={80} />;
    t13 = cn("font-800 text-Gray-white typo-h5", "mobile-tablet:font-700 mobile-tablet:typo-body2");
    $[33] = t12;
    $[34] = t13;
  } else {
    t12 = $[33];
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex max-w-[27.5rem] flex-col items-center gap-8">{t12}<p className={t13}>후기 작성하고<br />500P 받으세요!</p></div>;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== onClose || $[37] !== opened || $[38] !== t11) {
    t15 = <Modal opened={opened} onClose={onClose} className="bg-Gray-black" buttonFooter={t11}>{t14}</Modal>;
    $[36] = onClose;
    $[37] = opened;
    $[38] = t11;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
};